import React, { Component } from 'react';

class IconSidebarItemLead extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 40 25"
                style={{
                    enableBackground: "new 0 0 40 25",
                }}
                xmlSpace="preserve"
            >
                <path
                    d="M22.2 20.5c0-.5 0-1-.1-1.5-.6-3-2.4-5.1-5.2-6.2 2.4-1.7 3-4.6 2.3-6.8-.8-2.5-3.1-4.1-5.7-4.1S8.6 3.6 7.7 6c-.7 2.1-.1 5.1 2.3 6.8-.2.1-.3.1-.5.2-3 1.5-4.6 3.9-4.8 7.2v3c0 .6.3.9.9.9h15.6c.6 0 .9-.3.9-.9v-.7c.1-.7.1-1.4.1-2zM9.4 6.1c.6-1.4 1.7-2.3 3.1-2.6 1.5-.3 2.9.1 4.1 1.2-.3.3-.7.6-1.2.9-.8.4-1.7.6-2.7.7-1.1.2-2.2.1-3.3-.2zm9.1 13c-.3-.1-.7 0-.9.2-.1.2-.2.4-.2.6v2.7H9.7v-2.7c0-.4-.3-.8-.7-.8-.2 0-.4 0-.6.2-.2.2-.3.4-.3.6v2.7H6.3v-2.5c0-1.4.5-2.6 1.4-3.7.9-1.1 2.1-1.9 3.5-2.3.2.4.5.8.9 1.1-.4.7-.7 1.6-.8 2.7-.1.8-.2 1.7.1 2.6.3 1 .9 1.6 1.9 1.7 1 .2 2-.3 2.5-1.2.3-.6.5-1.3.4-2.2-.1-1.1-.3-2.1-.6-3-.1-.2-.2-.5-.3-.7V15c.3-.3.6-.6.8-1 .5.1 1 .3 1.5.6 1.9 1.1 3 2.7 3.3 4.8.1.5.1 1.1.1 1.6v1.5h-2v-2.7c0-.3-.2-.6-.5-.7zm-7-7.3C9.9 11 8.9 9.3 9.1 7.6c1.4.4 2.9.4 4.4.2 1.7-.3 3-.8 4.1-1.8.6 1.3.6 3.3-.8 4.8-1.3 1.5-3.5 1.9-5.3 1zm1.4 2.1h1.2c-.2.1-.4.1-.6.1-.2.1-.4 0-.6-.1zm1.6 5.5c0 .3-.1.6-.2.9-.1.3-.4.4-.7.4-.3 0-.5-.2-.7-.5-.2-.4-.2-.8-.2-1.2 0-1.1.2-2 .6-2.9.1-.2.2-.3.3-.5.2.3.4.6.5.9.3 1 .4 1.9.4 2.9z"
                    fill={this.props.isActive ? "#26A" : "#424242"}
                />
            </svg>
        );
    }
}

export default IconSidebarItemLead;